import React from "react";
import '../Style.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
} from "react-router-dom";
import $ from "jquery";
import logo from '../Assets/Images/logo-short.png';

import seyali_logo from '../Assets/Images/Seyali_logo.png';
import leature_logo from '../Assets/Images/Leature_logo.png';



function Footer() {
    return (
        <div>
            <section id="footer-section">
                <div className="container pt-4">
                    <div className="text-center pb-4">
                        <a href="/">
                            <img class="footer-logo-css" src={logo} />
                            {/* <p >The value of weighing</p> */}
                        </a>
                    </div>
                    <div className="row row-cols-lg-3 row-cols-1 g-4 justify-content-center text-center align-items-center">
                        <div className="col">

                            <div className="d-none d-lg-block">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d982.5410808181729!2d78.129736!3d9.920269!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c59ccefd10bd%3A0x2483b741b08b3b6d!2sEconomic%20Scales%20%7C%20Weighing%20Machine%20dealers%20in%20Madurai%7C%20Weighing%20Scale%20Manufacturer%7CCash%20Counting%20Machine!5e0!3m2!1sen!2sin!4v1734436811530!5m2!1sen!2sin" width="300" height="300" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            <div className="d-block d-lg-none">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1965.0821616363457!2d78.129736!3d9.920269!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c59ccefd10bd%3A0x2483b741b08b3b6d!2sEconomic%20Scales%20%7C%20Weighing%20Machine%20dealers%20in%20Madurai%7C%20Weighing%20Scale%20Manufacturer%7CCash%20Counting%20Machine!5e0!3m2!1sen!2sin!4v1734758804938!5m2!1sen!2sin" width="200" height="200" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                        <div className="col ">
                            <p className="about-card-heading-css mb-2">Reach Us</p>
                            <ul className="footer-ul-css px-0">
                                <li className="">
                                    Economic Scales
                                </li>
                                <li>
                                    58/ F1, Munichalai Road,
                                </li>
                                <li>
                                    Near Corporation Hospital,

                                </li>
                                <li>
                                    Madurai, Tamil Nadu 625009

                                </li>
                            </ul>

                        </div>
                        <div className="col ">
                            <p className="about-card-heading-css mb-2">Contact Us</p>
                            <ul className="footer-ul-css px-0">

                                <li>
                                    94430 30062
                                </li>
                                <li>
                                    76677 30062
                                </li>
                                <li>
                                    94425 30062
                                </li>
                            </ul>
                        </div>
                        {/* <div className="col ">
                            <p className="about-card-heading-css mb-2">Our Clients</p>
                            <ul className="footer-ul-css px-0">
                                <li className="">
                                    Appollo Hospitals
                                </li>
                                <li>
                                    Amma Unavagam
                                </li>
                                <li>
                                    AVN Ayurvedtha
                                </li>
                                <li>
                                    CSIR
                                </li>
                                <li>
                                    Hamarah Periya Cements Pvt Ltd
                                </li>
                                <li>
                                    Devadoss Hospitals
                                </li>
                                <li>
                                    Meenakshi Mission
                                </li>
                                <li>
                                    Sterling Holiday Resorts
                                </li>
                                <li>
                                    Big Bazar
                                </li>
                            </ul>
                        </div> */}
                    </div>
                    <div className="row row-cols-lg-1 row-cols-1 justify-content-cenetr  pt-4 ">
                        <div className="col  text-center">
                            <p className="about-card-para-css">
                                Copyrights © 2025 All Rights Reserved by Economic Scales.
                            </p>
                        </div>
                        <div className="col d-flex flex-row flex-wrap text-center justify-content-center">
                            <a href="https://seyali.in/" target="_blank">
                                <p className="about-card-para-css">
                                    Powered by <span className="ps-2"><img class="poweredby-logo-css " src={seyali_logo}></img></span>

                                </p>
                            </a>
                            <p className="border-left mx-lg-2 mx-2">

                            </p>
                            <a href="https://www.leaturetech.com/" target="_blank">
                                {/* <p className="brand-text-styling ">Leature Technologies</p> */}
                                <span className=""><img class="poweredby-logo-css " src={leature_logo}></img></span>
                            </a>

                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
}

export default Footer;
